"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _videoBuffer = require("./video-buffer.effect");

const VideoBufferBar = ({
  videoTag
}) => {
  const {
    bufferedUntilPercentage
  } = (0, _videoBuffer.useVideoBuffer)(videoTag);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "video-buffer-bar",
    style: {
      width: "".concat(bufferedUntilPercentage, "%")
    }
  });
};

VideoBufferBar.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element)
};
VideoBufferBar.defaultProps = {
  videoTag: null
};
var _default = VideoBufferBar;
exports.default = _default;